// Screens and controls that have no backend behind them (they were hardcoded demos in
// the vendor build). They stay in the codebase and show only when the app runs on mock
// data, so they can be reviewed against Figma without shipping placeholder content.
// See INT-38 spec §5.1 / decision D5.
export const MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === "true";

export const hiddenFeatures = {
  /** Engagement Center → "Health Priority Checklist" tab (hardcoded hypertension/CKD plan). */
  priorityChecklist: !MOCK_DATA,
  /** Engagement Center → "Create Visit Summary" modal (hardcoded). */
  visitSummary: !MOCK_DATA,
  /** Engagement Center → "Knowledge Check" tab (hardcoded quizzes). */
  knowledgeCheck: !MOCK_DATA,
  /** PathFinder → "Atlas" tab (hardcoded wellness cards). */
  atlas: !MOCK_DATA,
  /** "Listen" (text-to-speech) on a path — played a static mp3 in the vendor build. Always hidden until a real TTS exists. */
  listen: true,
  /** Apple sign-in — needs a new Apple key (the old one is being revoked); hidden until configured in Firebase. */
  appleSignIn: true,
} as const;

export const isHidden = (feature: keyof typeof hiddenFeatures) => hiddenFeatures[feature];
